import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I am currently working as a{" "}
              <b className="purple">Java Backend Developer</b> at{" "}
              <span className="purple">Procure Tiger Private Limited.</span>, where I
              contribute to the development and maintenance of{" "}
              <span className="purple">ABC Procure</span>, a large-scale enterprise
              e-Procurement platform used for managing tenders, auctions, RFQs,
              payments, document management, and workflow automation.
              <br />
              <br />
              I primarily work with
              <i>
                <b className="purple">
                  {" "}
                  Java, Spring MVC, Spring Boot, Hibernate, JSP, Servlets, SQL Server,
                  MySQL, Maven, and Apache Tomcat.
                </b>
              </i>
              <br />
              <br />
              My experience includes developing backend modules, REST APIs, payment
              integrations, digital signature functionality, production support,
              performance optimization, and maintaining large legacy enterprise
              applications.
              <br />
              <br />
              I am passionate about designing scalable backend systems and continuously
              expanding my knowledge in
              <i>
                <b className="purple">
                  {" "}
                  Microservices, System Design, AWS, Docker, Kubernetes, Kafka, and
                  AI/LLM technologies.
                </b>
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img
                src={"https://res.cloudinary.com/dpdh2nryr/image/upload/v1729011508/uploads/jmpwipduglak5khed3uk.jpg"}
                className="img-fluid rounded-circle"
                alt="avatar"
              />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/akul09"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://x.com/gehlotakul09?t=LjgNHfexXOvi6tp329S0fg&s=09"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/akul-gehlot-bb2190232"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/akul_santosh_gehlot?igsh=MWM5NWJ1czRlbzJ6MQ=="
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Home2;
